angular.module('salesPath2.spd')
.factory('spdTmpSalesProducts', [function() {

    /*
     * Dopisane "recznie" atrybuty pakietu na skutek braku SPD - do udekorowania w docelowej aplikacji
     */
    var spdTmpSalesProducts = {};
    return spdTmpSalesProducts;
  }])
;